import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

// Import Swiper React components and styles
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import starIcon from '../assets/images/star-icon.png';

const Testimonials = () => {
    const { t } = useTranslation();
    const reviews = [
        { quote: t('testimonial1_quote'), customer: 'Rolex Trought', designation: t('testimonial_designation') },
        { quote: t('testimonial2_quote'), customer: 'Alina Jame', designation: t('testimonial_designation') },
        { quote: t('testimonial3_quote'), customer: 'Kevin Andrew', designation: t('testimonial_designation') },
        { quote: t('testimonial4_quote'), customer: 'Nazish Ehtaon', designation: t('testimonial_designation') },
        { quote: t('testimonial5_quote'), customer: 'John Clark', designation: t('testimonial_designation') },
        { quote: t('testimonial6_quote'), customer: 'Zampa Devo', designation: t('testimonial_designation') },
    ];
    
    return (
        <section className="float-left w-100 testimonials-con position-relative padding-top main-box">
            <Container fluid>
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">{t('testimonials_title')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s" dangerouslySetInnerHTML={{ __html: t('testimonials_subtitle') }}></h2>
                </div>
                <div className="wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                    <Swiper
                        modules={[Pagination]}
                        pagination={{ clickable: true }}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop={true}
                        breakpoints={{
                            768: { slidesPerView: 2 },
                            1000: { slidesPerView: 4 },
                        }}
                        className="py-5"
                    >
                        {reviews.map((review, index) => (
                            <SwiperSlide key={index}>
                                <div className="testimonial-box">
                                    <figure><img src={starIcon} alt="stars" className="img-fluid" /></figure>
                                    <p>{review.quote}</p>
                                    <span className="d-block customer font-weight-600">{review.customer}</span>
                                    <span className="d-block designation font-weight-500">{review.designation}</span>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </Container>
        </section>
    );
};

export default Testimonials;